module.exports = __webpack_public_path__ + "static/img/G1.0002ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/G1.png
// module id = zBuV
// module chunks = 1